import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const base_url = process.env.REACT_APP_API_URL;

export default function PaymentSettings() {
const token = localStorage.getItem("admin_token");
  const [form, setForm] = useState({
    upi_id: "",
    bank_name: "",
    account_no: "",
    ifsc: "",
    usdt_address: "",
  });

  const [qrImage, setQrImage] = useState(null);
  const [qrPreview, setQrPreview] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 🔹 GET DATA
  const fetchSettings = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/admin/payment-settings`,
        {
          headers: { Authorization: token },
        }
      );

      if (res.data.data) {
        setForm({
          upi_id: res.data.data.upi_id || "",
          bank_name: res.data.data.bank_name || "",
          account_no: res.data.data.account_no || "",
          ifsc: res.data.data.ifsc || "",
          usdt_address: res.data.data.usdt_address || "",
        });

        setQrPreview(res.data.data.qr_image);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleSubmit = async () => {
    try {
      const data = new FormData();

      Object.keys(form).forEach((key) => {
        data.append(key, form[key]);
      });

      if (qrImage) {
        data.append("qr_image", qrImage);
      }

      await axios.post(
        `${base_url}/api/admin/payment-settings`,
        data,
        {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Payment settings saved");
      fetchSettings();
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="px-4">
      <h3>Payment Settings</h3>

      <div className="card p-3 mt-3">

        <input
          className="form-control mb-2"
          placeholder="UPI ID"
          name="upi_id"
          value={form.upi_id}
          onChange={handleChange}
        />

        {/* QR Upload */}
        <input
          type="file"
          className="form-control mb-2"
          onChange={(e) => setQrImage(e.target.files[0])}
        />

        {/* QR Preview */}
        {qrPreview && (
          <img
            src={`${base_url}/uploads/${qrPreview}`}
            alt="QR"
            width="120"
            className="mb-2"
          />
        )}

        <input
          className="form-control mb-2"
          placeholder="Bank Name"
          name="bank_name"
          value={form.bank_name}
          onChange={handleChange}
        />

        <input
          className="form-control mb-2"
          placeholder="Account Number"
          name="account_no"
          value={form.account_no}
          onChange={handleChange}
        />

        <input
          className="form-control mb-2"
          placeholder="IFSC Code"
          name="ifsc"
          value={form.ifsc}
          onChange={handleChange}
        />

        <input
          className="form-control mb-2"
          placeholder="USDT Address"
          name="usdt_address"
          value={form.usdt_address}
          onChange={handleChange}
        />

        <button className="btn btn-success mt-2" onClick={handleSubmit}>
          Save
        </button>

      </div>
    </div>
    
  );
}